export default __webpack_public_path__ + "static/asleep-0e7c69c94e0564ac35ea69b04d2055b0.svg";